import AssemblyMixins from "@/mixins/AssemblyMixins.js"

export default {
	mixins: [AssemblyMixins],
	data() {
		return {
			selectorModal: {
				visible: false,
				payload: {
					type: "Material",
					field_values_json: ""
				}
			},
			materialEditModal: {
				visible: false,
				record: null,
				title: "Edit Material",
				currentLabourHrs: null
			},
			assemblyEditModal: {
				visible: false,
				record: null,
				payload: {
					qty: 1,
					num_segments: 1,
					linear_qty: 1
				}
			},
			assemblyDetailsModal: {
				visible: false,
				record: null,
				title: "Assembly Anatomy",
				assemblyItems: []
			},
			selectedMaterials: [],
			toggleBulkMarkup: false,
			toggleBulkAdjustment: false,
			bulkMarkup: 1,
			bulkPriceAdjustment: 1,
			assemblies: [],
			assemblyFields: [
				{label: "Description",key: "description"},
				{label: "Length",key: "lengthWithUnit",align:'right'},
				{label: "# Segs.",key: "num_segments",align: 'right'},
				{label: "Qty",key: 'qty',align:'right'},
				{label: "Price Adj.",key: "priceAdjustment",align: 'right'},
				{label: "Markup",key: "markup",align: 'right'},
				{label: "Labour Total",key: "labourTotal",align: 'right'},
				{label: "Sub-total",key: 'assemblySubTotal',align: 'right'},
				{label: "Price Total",key: "assemblyPrice",align: 'right'}
			]
		}
	},
	computed: {
		hasAssemblies() {
			if (this.billingDocumentAssemblies.length > 0)
				return true

			return false
		},
		mutatedAssemblies() {
			let vm = this

			/*
			this.billingDocumentAssemblies.forEach(as => {
				this.postData("ServiceInvoiceObject/delete",{id:as.id})
			})

			this.billingDocumentMaterials.forEach(mat => {
				this.postData("ServiceInvoiceObject/delete",{id:mat.id})
			})
			*/

			return this.billingDocumentAssemblies.map(as => {

				let markup = 1, priceAdjustment = 1
				if ("priceAdjustment" in as)
					priceAdjustment = +as.priceAdjustment
				if ("markup" in as)
					markup = +as.markup

				as.markup = markup.toFixed(3)
				as.priceAdjustment = priceAdjustment.toFixed(3)

				let unit_type = ""
				if ("unit_type" in as)
					unit_type = as.unit_type
				else if ("assembly" in as && as.assembly && "unit_type" in as.assembly)
					unit_type = as.assembly.unit_type

				let lengthUnitLabel = unit_type.toLowerCase()
				if (unit_type != 'Unit') {
					as.lengthWithUnit = as.linear_qty + " " + lengthUnitLabel
					as.labourTotalRaw = +as.labour_hrs_per_assembly + (+as.labour_hrs_per_unit * +as.qty) + (+as.labour_hrs_per_segment * +as.num_segments)
				}
				else {
					as.lengthWithUnit = ""

					as.labourTotalRaw = +as.labour_hrs_per_assembly * +as.qty
				}

				as.assemblyPriceRaw = vm.calcAssemblyTotalPrice(as)

				as.labourTotal = as.labourTotalRaw.toCurrency()
				as.assemblySubTotal = as.assemblyPriceRaw.toCurrency()

				let totalLineItemPrice = as.assemblyPriceRaw * as.qty
				as.assemblyPrice = totalLineItemPrice.toCurrency()



				if ("isDisconnected" in as && as.isDisconnected) {
					as.markup = "N/A"
					as.priceAdjustment = "N/A"
					as.assemblySubTotal = "N/A"
					as.assemblyPrice = "N/A"

					if (as.description.indexOf("(disconnected from materials)") == -1) 
						as.description += " (disconnected from materials)"

					as.rowTitle = "This assembly has been disconnected from its child materials. It exists now only as a historical record that this assembly has been added to the bid component, however all its child materials have now been convered to standalone materials"
				}

				return as
			})
		},
		mutatedAndCondensedMaterials() {
			let vm = this, materials = []

			if (this.billingDocumentMaterials) {

				materials = vm.condenseMaterials(this.billingDocumentMaterials)

				materials = materials.filter(mat => !('itemType' in mat) || mat.itemType != 'assembly').map(material => {

					material = vm.mutateMaterial(material)

					//recalc labourTotal in case hrs, qty or per has been changed manually
					let labourTotal = +material.labour_hrs * +material.qty / +material.per
					material.labourTotal = labourTotal.toFixed(2)

					if (material.belongsToAssembly && vm.mutatedAssemblies.length == 0 && material.parentAssemblies.length > 0) {
						material.belongsToAssembly = false
						delete material.rowClasses
					}

					material.priceUpdatedAt = material.price_updated != '0000-00-00' && material.price_updated != null ? vm.formatDate(material.price_updated) : vm.formatDate(material.created_at)

					return material
				})
			}

			return materials
		}
	},
	methods: {
		materialsMatchForCondensing(matA, matB) {
			let condensed = [matA, matB].map(mat => ({
				material_id: mat.material_id,
				price: +mat.price,
				priceAdjustment: +mat.priceAdjustment,
				markup: +mat.markup
			}))

			let a = condensed[0]
			let b = condensed[1]
			let matchFields = ['material_id', 'price', 'priceAdjustment', 'markup']
			let matches = true

			matchFields.forEach(field => {
				if (a[field] != b[field])
					matches = false
			})

			return matches
		},
		materialsFields(hasAssemblies) {
			let fields = [
				{label: "Description",key:"description"},
				{label: "Part #",key:"part_number"},
			]

			if (hasAssemblies)
				fields.push({label: "Source",key:'sourceAssemblyDescription'})

			fields = fields.concat([
				{label: "Price Updated",key:'priceUpdatedAt'},
				{label: "Qty",key:"qty",align:"right"},
				{label: "Price",key:"price",align:"right"},
				{label: "Per",key:"per",align:"right"},
				{label: "",key:'material_unit_type'},
				{label: "Price Adj.",key: "priceAdjustmentFormatted",align:"right"},
				{label: "Markup",key: "markupFormatted",align:"right"},
				{label: "Labour Hours",key: "labourTotal",align:"right"},
				{label: "Unit Total",key: "unit_total",align:"right"},
				{label: "Line Total",key: "total",align:"right"}
			])

			return fields
		},
		calcAssemblyBasePrice(assembly) {
			return (
				+assembly.price_per_assembly
				+ (+assembly.price_per_unit * +assembly.linear_qty)
				+ (+assembly.price_per_segment * +assembly.num_segments)
			)
		},
		calcAssemblyTotalPrice(assembly) {

			return this.calcAssemblyBasePrice(assembly)
				* +assembly.priceAdjustment 
				* +assembly.markup
		},
		assemblyItemsFetched(items) {
			this.assemblyDetailsModal.assemblyItems = items	
		},
		condenseMaterials(materials) {
		  const vm = this
		  let condensedMaterials = []

		  ;(materials || []).forEach(raw => {
			let idx = condensedMaterials.findIndex(cm => vm.materialsMatchForCondensing(cm, raw))

			if (idx >= 0) {
			  // merge
			  condensedMaterials[idx].qty = +condensedMaterials[idx].qty + +raw.qty

			  // merge parentAssemblies if present
			  if ("parentAssemblies" in condensedMaterials[idx] && "parentAssemblies" in raw) {
				condensedMaterials[idx].parentAssemblies =
				  condensedMaterials[idx].parentAssemblies.concat(raw.parentAssemblies)
			  } else if (!("parentAssemblies" in condensedMaterials[idx]) && "parentAssemblies" in raw) {
				condensedMaterials[idx].parentAssemblies = vm.cloneObj(raw.parentAssemblies)
			  }

			  condensedMaterials[idx].merged = true

			  const shallowCopy = { ...raw } // keep original shape for provenance
			  delete shallowCopy.sourceObjects
			  if (!Array.isArray(condensedMaterials[idx].sourceObjects))
				condensedMaterials[idx].sourceObjects = []
			  condensedMaterials[idx].sourceObjects.push(shallowCopy)
			} else {
			  // seed new
			  const base = vm.cloneObj(raw)
			  base.merged = false
			  const shallowCopy = { ...raw }
			  delete shallowCopy.sourceObjects
			  base.sourceObjects = [shallowCopy]
			  condensedMaterials.push(base)
			}
		  })

		  return condensedMaterials
		},
		//pushes to a materials array without adding duplicates (instead it adds to the qty when a matching material is found). Returns the entire resulting array
		pushToMaterials(materials, matToPush, assemblyId) {
			const vm = this

			// -------------------------------------------------
			// 1) Normalize identity
			// -------------------------------------------------

			// Catalog materials: material_id or id
			let materialId = matToPush.material_id || matToPush.id || null

			// Manual materials: assign a stable synthetic id so they never merge accidentally
			if (!materialId) {
				materialId = "__manual__" + vm.moment().valueOf() + "_" + Math.random().toString(36).substr(2, 5)
			}

			matToPush.material_id = materialId
			delete matToPush.id

			// -------------------------------------------------
			// 2) Normalize pricing
			// -------------------------------------------------

			const priceAdjustment =
				("priceAdjustment" in matToPush && matToPush.priceAdjustment != null)
					? +matToPush.priceAdjustment
				: ("price_adjustment" in matToPush && matToPush.price_adjustment != null)
					? +matToPush.price_adjustment
				: vm.getCustomerDefaultPriceAdjustment()

			const markup =
				("markup" in matToPush && matToPush.markup != null)
					? +matToPush.markup
					: vm.getCustomerDefaultMarkup()

			matToPush.priceAdjustment = priceAdjustment
			matToPush.markup = markup

			// -------------------------------------------------
			// 3) Clone destination array
			// -------------------------------------------------

			let mergedMaterials = vm.cloneObj(materials)

			// -------------------------------------------------
			// 4) Normalize parent assembly reference
			// -------------------------------------------------

			let parentAssemblyRef = null
			if (assemblyId) {
				parentAssemblyRef = {
					assembly_id: assemblyId,
					qty: +matToPush.qty
				}
			}

			// -------------------------------------------------
			// 5) Find merge candidate
			// -------------------------------------------------

			let foundIndex = mergedMaterials.findIndex(existing => {

				if (!vm.materialsMatchForCondensing(existing, matToPush))
					return false

				// standalone materials can merge freely
				if (!assemblyId)
					return true

				// assembly materials: only merge within SAME assembly instance
				if (!existing.parentAssemblies || !Array.isArray(existing.parentAssemblies))
					return false

				return existing.parentAssemblies.some(pa => +pa.assembly_id === +assemblyId)
			})

			// -------------------------------------------------
			// 6) Merge or insert
			// -------------------------------------------------

			if (foundIndex >= 0) {

				mergedMaterials[foundIndex].qty =
					+mergedMaterials[foundIndex].qty + +matToPush.qty

				if (assemblyId)
					mergedMaterials[foundIndex].parentAssemblies.push(parentAssemblyRef)

			} else {

				if (assemblyId)
					matToPush.parentAssemblies = [parentAssemblyRef]

				mergedMaterials.push(matToPush)
			}

			return mergedMaterials
		},
		removeUneededFields(object) {
			let fieldsToStrip = [
				"rowClasses",
				"selected",
				"assemblyPrice",
				"tagsList",
				"fieldId",
				"AssemblyTag",
				"comments",
				"deleted"
			]

			fieldsToStrip.forEach(field => {
				delete object[field]
			})

			return object
		},
		getCustomerDefaultMarkup() {
			let defaultMarkup = 1

			if (this.clientInvoiceSettings && "useMarkup" in this.clientInvoiceSettings && this.clientInvoiceSettings.useMarkup && +this.clientInvoiceSettings.default_markup != 0) 
				defaultMarkup = +this.clientInvoiceSettings.default_markup	
			else 
				//check for global settings
				defaultMarkup = this.getDefaultPriceSetting("Material","markup")

			return defaultMarkup
		},
		getCustomerDefaultPriceAdjustment() {
			let defaultPriceAdjustment = 1

			if (this.clientInvoiceSettings && "usePriceAdjustment" in this.clientInvoiceSettings && this.clientInvoiceSettings.usePriceAdjustment && +this.clientInvoiceSettings.default_price_adjustment != 0) {
				defaultPriceAdjustment = +this.clientInvoiceSettings.default_price_adjustment
			}
			else  {
				//check for global settings
				defaultPriceAdjustment = this.getDefaultPriceSetting("Material","price_adjustment")
			}

			return defaultPriceAdjustment
		},
		//expands assemblies with their nested materials into a flat material list. Returns list of expanded raw materials, as well as batchpayload (which includes the assemblies)
		expandMaterials(payload,defaultMarkup,defaultPriceAdjustment,billingDocumentObjectResource) {
			let expandedMaterials = [], batchPayload = [], assemblies = []
			let vm = this

			payload.forEach(payloadItem => {

				payloadItem.belongsToAssembly = false

				if ("itemType" in payloadItem && payloadItem.itemType == 'assembly') {

					let assemblyObj = vm.cloneObj(payloadItem.assembly)

					assemblyObj.num_segments = payloadItem.num_segments
					assemblyObj.qty = +payloadItem.qty
					assemblyObj.linear_qty = +payloadItem.linear_qty
					assemblyObj.priceAdjustment = defaultPriceAdjustment
					assemblyObj.markup = defaultMarkup

					vm.assemblies.push(assemblyObj)

					let payload = vm.removeUneededFields(vm.cloneObj(assemblyObj))

					payload.type = "Assembly"
					payload.assembly_id = assemblyObj.id
					payload.priceAdjustment = "priceAdjustment" in payloadItem ? payloadItem.priceAdjustment : defaultPriceAdjustment
					payload.markup = "markup" in payloadItem ? payloadItem.markup : defaultMarkup
					payload.addedAt = vm.moment().utc().format("YYYY-MM-DD HH:MM:SS")
					
					payload[vm.documentIdMap[billingDocumentObjectResource]] = vm.billingDocumentId

					delete payload.id

					//save Assembly as ServiceInvoiceObject
					/*promises.push(vm.saveObject({
						visible: false,
						payload,
					},true,vm.billingDocumentObjectResource)) //2nd arg to suppress emit
					*/
					batchPayload.push(vm.renderDocumentObjectPayload(payload,billingDocumentObjectResource))

					assemblies.push(payloadItem)

					payloadItem.materials.forEach(assemblyMat => {
						let cleaned = vm.removeUneededFields(vm.cloneObj(assemblyMat))

						if ("assembly" in cleaned && cleaned.assembly) 
							cleaned.assembly = vm.removeUneededFields(cleaned.assembly)

						//cleaned.sourceAssemblyId = payloadItem.id
						cleaned.belongsToAssembly = true

						//inherit markup/price_adjustment from assembly
						cleaned.priceAdjustment = payloadItem.priceAdjustment
						cleaned.markup = payloadItem.markup

						expandedMaterials = this.pushToMaterials(expandedMaterials, cleaned,assemblyObj.id)
					})
				}
				else {
					payloadItem.material_id = payloadItem.id

					expandedMaterials = this.pushToMaterials(expandedMaterials, payloadItem)
				}
			})

			expandedMaterials = expandedMaterials.map(mat => {
				if (!("markup" in mat) || !mat.markup) 
					mat.defaultMarkup = defaultMarkup
					
				if (!("priceAdjustment" in mat) || !mat.priceAdjustment) 
					mat.priceAdjustment = defaultPriceAdjustment

				return mat
			})

			expandedMaterials.forEach(mat => {

				if (mat.qty != 0) {

					vm.selectorModal.payload = JSON.parse(JSON.stringify(mat))

					let per = 1
					vm.selectorModal.payload.per = 1
					if ("per" in mat) {
						per = +mat.per
						vm.selectorModal.payload.per = +mat.per
					}

					vm.selectorModal.payload.labourTotal = ""
					if (mat.labour_hrs > 0) {
						vm.selectorModal.payload.labourTotal = +mat.labour_hrs * +mat.qty / per

						vm.selectorModal.payload.labourTotal = vm.selectorModal.payload.labourTotal.toFixed(3)
					}

					vm.selectorModal.payload.type = "Material"

					//set the payload's document id (invoice_id, quote_id, bid_component_id)
					vm.selectorModal.payload[vm.documentIdMap[billingDocumentObjectResource]] = vm.billingDocumentId

					let unitTotal = +mat.price / +per
					vm.selectorModal.payload.unit_total = unitTotal.toCurrency()

					let lineTotal = +mat.qty * unitTotal

					if (!("per" in mat) || !mat.per)
						mat.per = 1

					vm.selectorModal.payload.rate = +mat.price / +mat.per

					vm.selectorModal.payload.total = lineTotal.toCurrency()
					vm.selectorModal.payload.totalRaw = lineTotal

					if ("labour_hrs" in mat) 
						vm.selectorModal.payload.labour_hrs = mat.labour_hrs

					delete vm.selectorModal.payload.id

					vm.selectorModal.payload.object_id = vm.selectorModal.payload.material_id

					if ("quote_id" in mat)
						vm.selectorModal.payload.quote_id = mat.quote_id
					if ("invoice_id" in mat)
						vm.selectorModal.payload.invoice_id = mat.invoice_id

					batchPayload.push(vm.renderDocumentObjectPayload(vm.selectorModal.payload,billingDocumentObjectResource))

					//promises.push(vm.saveObject(vm.selectorModal,true,vm.billingDocumentObjectResource))
				}
			})

			return {
				expandedMaterials,
				batchPayload,
				assemblies
			}
		},
		normalizeMaterials(materials) {

			let materalsObj = materials

			if (typeof materials == 'string') {
				try {
					materalsObj = JSON.parse(materials)
				}
				catch (ex) {
					materalsObj = []
				}
			}

			let vm = this

			return materalsObj.map(mat => {

				if (!("price" in mat) && "material_price" in mat)
					mat.price = mat.material_price
				else if (!("price" in mat))
					mat.price = 0

				if (!("per" in mat))
					mat.per = 1

				mat = vm.applyPriceAdjustmentAndMarkup(mat)

				mat.material_id = mat.id

				let fieldsToStrip = [
					"rowClasses",
					"selected",
					"assemblyPrice",
					"tagsList",
					"fieldId",
					"AssemblyTag",
					"comments",
					"deleted"
				]

				fieldsToStrip.forEach(field => {
					delete mat[field]
				})

				return mat
			})
		},
		addMaterials(payload) {
			let vm = this

			vm.spinner(true)
			vm.selectorModal.working = true

			let noAssemblies = this.assemblies.length == 0 ? true : false

			//find default markup/price adjustments
			let defaultMarkup = this.getCustomerDefaultMarkup()

			let defaultPriceAdjustment = this.getCustomerDefaultPriceAdjustment()
			let promises = []

			let expanded = this.expandMaterials(payload,defaultMarkup,defaultPriceAdjustment,vm.billingDocumentObjectResource)

			let batchPayload = expanded.batchPayload

			return new Promise((resolve,reject) => {

				vm.postData(vm.billingDocumentObjectResource + "/save-batch",{records:JSON.stringify(batchPayload)}).then(response => {
					if (vm.assemblies.length > 0 && noAssemblies) {
						//added our first assembly, flip to the assemblies tab
						vm.assemblyView = true
					}

					vm.spinner(false)

					vm.$emit("modelChanged") //now we can emit
					vm.selectorModal.visible = false
					vm.selectorModal.working = false

					resolve(response)
				})

			})
		},
		deleteAssembly(record) {

			if (!("id" in record) && "objectRecordId" in record)
				record.id = record.objectRecordId

			//remove all qtys of materials that belong to this assembly and re-add them
			let vm = this

			let materialsRemoved = {}
			let promises = []

			let updateRecords = []
			this.billingDocumentMaterials.filter(mat => {
				if ("parentAssemblies" in mat && mat.parentAssemblies) {
					let parentAssemblyLink = mat.parentAssemblies.find(asLinks => asLinks.assembly_id == record.assembly_id)
					if ("parentAssemblies" in mat && parentAssemblyLink) 
						return true
				}
				return false
			}).forEach(mat => {
				let fields = vm.cloneObj(mat)

				let parentAssemblyLink = mat.parentAssemblies.find(asLinks => asLinks.assembly_id == record.assembly_id)

				let materialId = mat.material_id

				if (!(materialId in materialsRemoved) || +parentAssemblyLink.qty > materialsRemoved[materialId]) {
					//there haven't been enough materials removed yet

					let roundedParentAssemblyQty = +parentAssemblyLink.qty
					roundedParentAssemblyQty = roundedParentAssemblyQty.round(3)

					let fieldsQty = +fields.qty

					fieldsQty -= roundedParentAssemblyQty

					//add this to the list of materials that have been removed, so we make sure we don't remove too much
					materialsRemoved[materialId] = parentAssemblyLink.qty

					let id = "objectRecordId" in mat ? mat.objectRecordId : mat.id

					if (fieldsQty == 0) 
						promises.push(vm.postData(vm.billingDocumentObjectResource+"/delete",{id})) //taken down to 0 so we can delete the whole ServiceInvoiceObject
					
					else {
						//find parent assemblies entry
						let assemblyLinkIndex = mat.parentAssemblies.findIndex(asLinks => asLinks.assembly_id == record.assembly_id)

						fields.parentAssemblies.splice(assemblyLinkIndex,1) 

						let recordPayload = {
							id,
							field_values_json: JSON.stringify(fields),
							qty: fieldsQty
						}

						if (vm.billingDocumentObjectResource == 'ServiceInvoiceObject')
							recordPayload.invoice_id = vm.billingDocumentId
						else if (vm.billingDocumentObjectResource == 'JobChangeOrderObject')
							recordPayload.quote_id = vm.billingDocumentId
						else if (vm.billingDocumentObjectResource == 'JobBidComponentObject')
							recordPayload.bid_component_id = vm.billingDocumentId

						//not taken down to zero, so we have to do an update
						updateRecords.push(recordPayload)
					}
				}
			})

			if (updateRecords.length > 0)
				promises.push(vm.postData(vm.billingDocumentObjectResource+"/save-batch",{records: JSON.stringify(updateRecords)})) //batch update
			
			promises.push(vm.getJSON("MaterialAssembly/find/"+record.assembly_id,{
					include:[{model:"MaterialAssemblyItem",include:["Material","LabourAction"]}]
				}))
			promises.push(vm.postData(vm.billingDocumentObjectResource+"/delete",{id: record.id}))
			
			return new Promise((resolve,reject) => {
				Promise.all(promises).then(responses => {

					vm.$emit("modelChanged")

					resolve(responses)
				})
			})
		},
		closeDetailsModal() {
			this.assemblyDetailsModal.visible = false
			this.assemblyEditModal.visible = true //for some reason this window is closing too, but we don't want it to
		},
		editAssembly(record) {
			this.assemblyEditModal.visible = true
			this.assemblyEditModal.payload = this.cloneObj(record)
			this.assemblyEditModal.record = record
		},
		viewAssemblyDetails() {
			let assembly = this.cloneObj(this.assemblyEditModal.record)

			this.assemblyDetailsModal.visible = true
			this.assemblyDetailsModal.title = "Assembly Anatomy: " + assembly.description
			this.assemblyDetailsModal.record = assembly
		},
		saveAssemblyEdit() {
			let vm = this

			//remove all qtys of materials that belong to this assembly and re-add them
			this.deleteAssembly(vm.assemblyEditModal.record).then(responses => {

				//now we can recalculate the assembly materials finally and re-add according to the edited values

				let assemblyFindResponseIndex = responses.length - 2
			
				if (responses[assemblyFindResponseIndex].success) {
					//build out payload to re-add materials

					let assemblyDetails = vm.cloneObj(responses[assemblyFindResponseIndex].data)
					delete assemblyDetails.MaterialAssemblyItem

					let payload = []

					let items = vm.createMaterialItemsFromAssemblyItems(
							responses[assemblyFindResponseIndex].data.MaterialAssemblyItem,
							vm.assemblyEditModal.payload.qty,
							vm.assemblyEditModal.payload.num_segments,
							vm.assemblyEditModal.payload.linear_qty
						)

					let assemblyItem = {
						assembly: assemblyDetails,
						description: assemblyDetails.description,
						qty: +vm.assemblyEditModal.payload.qty,
						linear_qty: +vm.assemblyEditModal.payload.linear_qty,
						priceAdjustment: +vm.assemblyEditModal.payload.priceAdjustment,
						markup: +vm.assemblyEditModal.payload.markup,
						itemType: "assembly",
						materials: items.materials,
						num_segments: vm.assemblyEditModal.payload.num_segments
					}

					payload.push(assemblyItem)

					vm.addMaterials(payload)

					vm.assemblyEditModal.visible = false
				}
			})
		}
	}
}